export default __webpack_public_path__ + "media/images/manual/joanr/08-0625e8602eed8fcb22c10ad3d6818ce2.png";